import { StackModel } from './PreferenceModel';
import { Purpose } from './Purpose';
import { getText } from '../../TranslationService';
import { TotalOptedIn } from '../shared/ConsentWidget/TotalOptedIn';
import { TriStateCheckbox } from '../shared/UiStates/TriStateCheckbox';
import { Accordion } from '../shared/Accordion';
import { AccordionHeader } from '../shared/Accordion/AccordionHeader';
import { AccordionContent } from '../shared/Accordion/AccordionContent';

type StackComponentModel = {
  stack: StackModel;
  onPurposeChangeHandler: (id: number, isOptedIn: boolean) => void;
  onStackChangeHandler: (args: any) => void;
};

export const Stack = ({ stack, onPurposeChangeHandler, onStackChangeHandler }: StackComponentModel) => {
  const changeHandler = () => {
    onStackChangeHandler(stack.id);
  };
  const uid = `stack-${stack.id}`;

  const accordionToggleProperties: { [name: string]: any } = {};
  if (!stack.isStackEnabled) accordionToggleProperties['checked'] = false;

  return (
    <Accordion uid={uid} settings={{ enabled: stack.isStackEnabled }}>
      <AccordionHeader
        uid={uid}
        title={getText(`stack_title_${stack.name}`)}
        rowIcon={
          <div class={`cc-icon  cc-icon-stack-${stack.id}`}>
            <em></em>
          </div>
        }
        afterTitleComponents={
          <TotalOptedIn optedIn={stack.TotalOptedInPurposes()} totalOptions={stack.TotalPurposes()} />
        }
        endComponents={
          <>
            <hr class="cc-accordion-separator" />
            <TriStateCheckbox id={stack.id.toString()} toggleState={stack.ToggleState} changeHandler={changeHandler} />
          </>
        }
      ></AccordionHeader>
      <AccordionContent>
        {stack.shouldDisplayDescription ? (
          <div class="ccm-row-option">
            <div class="ccm-col-description">{getText(`stack_description_${stack.name}`)}</div>
          </div>
        ) : null}
        <section class="purposes">
          {stack.Purposes.map((purpose) => (
            <Purpose purpose={purpose} onPurposeChangedHandler={onPurposeChangeHandler} />
          ))}
        </section>
      </AccordionContent>
    </Accordion>
  );
};
